<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('graduate_information').toUpper() }}</h5>
        <div v-for="(itm,key) in graduateData" :key="key">
            <div class="mb-2 d-flex">
                <b-button variant="light"
                          class="border w-40 h-40 mr-2"
                          v-b-toggle="'collapse-'+key">
                    <i class="ri-arrow-down-s-line"></i>
                </b-button>
                <div
                    class="flex-grow-1 bg-light w-40 h-40 border rounded-sm d-flex align-items-center pl-3 font-weight-bold">
                    {{ itm.university_name+'; '+itm.faculty+'; '+itm.program }}
                </div>
            </div>
            <b-collapse :id="'collapse-'+key">
                <div class="border rounded-sm p-4 mb-4">
                    <b-row>
                        <b-col cols="auto">
                            <b-form-group :label="$t('yoksis_student_id')">
                                <div class="label-as-input">
                                    {{itm.yoksis_student_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('student_number')">
                                <div class="label-as-input">
                                    {{itm.student_number}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('registration_date_just')">
                                <div class="label-as-input">
                                    {{itm.registration_date}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('graduate_date')">
                                <div class="label-as-input">
                                    {{itm.leaving_date}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('university')">
                                <div class="label-as-input">
                                    {{itm.university_name}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('faculty')">
                                <div class="label-as-input">
                                    {{itm.faculty}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('program')">
                                <div class="label-as-input">
                                    {{itm.program}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('mode_of_study')">
                                <div class="label-as-input">
                                    {{itm.education_type}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('program_period')">
                                <div class="label-as-input">
                                    {{itm.duration}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('unit_id')">
                                <div class="label-as-input">
                                    {{itm.unit_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('diploma_point')">
                                <div class="label-as-input">
                                    {{itm.diploma_point}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('ects')">
                                <div class="label-as-input">
                                    {{itm.ects_credit}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('grade_system')">
                                <div class="label-as-input">
                                    {{itm.diploma_point_system}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('diploma_number')">
                                <div class="label-as-input">
                                    {{itm.diploma_number}}
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<script>
//Template
//Component
//Other
//Service
import YoksisService from "@/services/YoksisService";
//Page


export default {
    props: {
        nationalId: {
            type: String,
            default: null
        }
    },
    components: {

    },
    data() {
        return {
            graduateData: null
        }
    },
    methods: {
        getData(nationalId){
            YoksisService.graduateInformation(nationalId).then(response => {
                this.graduateData = response.data.data
            }).catch(e => {
                this.$toast.error(e.data.message)
            })
        }
    },

    created(){
        this.getData(this.nationalId)
    }
};
</script>

